import {
  selectCurrentVersionId as selectCurrentVersionIdStrict,
  selectLatestActiveVersionId,
} from '@iconik-io/shared-lib/src/redux/entities/selectors/versions';

import type { AppState } from '../../store/types';

/**
 * Web route adapters over the shared-lib version selectors.
 *
 * A version id taken from `/asset/$id/v/$versionId` wins as-is. The shared-lib
 * selector resolves the newest ACTIVE version instead, so it returns undefined
 * for a version that is still IN_PROGRESS — which is exactly where creating a
 * version redirects, and would blank out everything keyed on the current
 * version until transcoding finished.
 */
export const selectCurrentVersionId = (
  state: AppState,
  assetId: string | undefined,
  versionId: string | undefined,
): string | undefined => {
  if (!assetId) {
    return undefined;
  }
  if (versionId) {
    return versionId;
  }
  return selectCurrentVersionIdStrict(state, assetId, undefined);
};

export const selectIsLatestVersion = (
  state: AppState,
  assetId: string | undefined,
  versionId: string | undefined,
): boolean => {
  const currentVersionId = selectCurrentVersionId(state, assetId, versionId);
  return Boolean(
    assetId &&
      currentVersionId &&
      currentVersionId === selectLatestActiveVersionId(state, assetId),
  );
};
